(function () {
    'use strict';

    angular.module("imApp").factory("inventoryArticleSearchService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 948,
                    parameters: parms || {}
                });
            },
            listInventoryArticles: function (parms) {
                return $ihttp.post({
                    method: 949,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
